var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExternalLinkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.25V14.75C13.5 15.1478 13.342 15.5294 13.0607 15.8107C12.7794 16.092 12.3978 16.25 12 16.25H3.75C3.35218 16.25 2.97064 16.092 2.68934 15.8107C2.40804 15.5294 2.25 15.1478 2.25 14.75V6.5C2.25 6.10218 2.40804 5.72064 2.68934 5.43934C2.97064 5.15804 3.35218 5 3.75 5H8.25M11.25 2.75H15.75M15.75 2.75V7.25M15.75 2.75L7.5 11",
    stroke: "#174BCF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExternalLinkBlue);
export default __webpack_public_path__ + "static/media/icon-external-link_blue.cf40a7715e950b730758d20baca8b71d.svg";
export { ForwardRef as ReactComponent };